module.exports = __webpack_public_path__ + "media/bundles/TriipApp/assets/images/logo-aa111020adf64b4b1189e8ede9c70d94.png";